import classnames from "classnames";

import { LocalEdit, LimitedInput } from "../../../../ui";
import { range } from "../../../../utils";
import { ImageContainer } from "../../../../media";
import layouts from "./layouts";
import style from "./style.module.scss";
import type { PageOptions, PhotoValue } from "../../../types";

interface LayoutProps {
  page?: PageOptions;
  onChange: (page: PageOptions) => void;
  productId?: string;
  userId?: string;
  isPreview?: boolean;
}

export function Layout({ page = {}, onChange, productId, userId, isPreview }: LayoutProps) {
  const photos = page?.photos || {};
  const labels = page?.labels || {};
  const selectedLayout = layouts.find((layout) => layout.value === (page.layout || "margin"))!;
  const changePhoto = (index: number) => (url: PhotoValue) =>
    onChange({ ...page, photos: { ...photos, [index]: url } });
  const changeLabel = (index: number) => (value: string) =>
    onChange({
      ...page,
      labels: { ...labels, [index]: value },
    });
  return (
    <div className={classnames(style.container, selectedLayout.style.container)}>
      {range(selectedLayout.countPhotos).map((index) => (
        <ImageContainer
          key={"photo-" + index}
          image={photos[index]}
          onChange={changePhoto(index)}
          productId={productId}
          userId={userId}
          className={selectedLayout.style["photo" + index]}
          imageClassName={selectedLayout.style["photoInner" + index]}
          isPreview={isPreview}
          aspectRatio={selectedLayout.photoAspectRatios?.[index] ?? 1}
          cropShape={selectedLayout.photoCropShapes?.[index] ?? "rect"}
        />
      ))}
      {range(selectedLayout.countLabels).map((index) => (
        <div
          key={"label-" + index}
          className={classnames(style.label, selectedLayout.style["label" + index])}
        >
          {isPreview && labels[index]}
          {!isPreview && (
            <LocalEdit
              value={labels[index] || ""}
              onChange={changeLabel(index)}
              render={({ value, onChange, onPersist }) => (
                <LimitedInput
                  type="textarea"
                  className={classnames(
                    style.label,
                    selectedLayout.style.label,
                    selectedLayout.style["label" + index],
                  )}
                  value={value}
                  placeholder="Mon image..."
                  onChange={(event) => onChange(event.target.value)}
                  onBlur={onPersist}
                />
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}
